import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["pdfPreviewLink"];

  previewPdf(event) {
    const file = event.target.files[0];

    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
    }

    if (file) {
      this.currentObjectUrl = URL.createObjectURL(file);
      this.pdfPreviewLinkTarget.href = this.currentObjectUrl;
      this.pdfPreviewLinkTarget.classList.remove("is-hidden");
    } else {
      this.pdfPreviewLinkTarget.classList.add("is-hidden");
    }
  }
}
